import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleVesselActivity = {
  namespaced: true,

  state: {
    name: 'vessel-activity',
    vesselActivities: []
  },

  mutations,
  getters,
  actions
}

export default moduleVesselActivity;